<template>
  <div
    class="table-saved-filters f-column"
    style="min-height: 0; max-width: 100vw; max-height: 100vh; overflow: hidden"
  >
    <div class="f-align-center w-100 no-scroll-track">
      <div
        class="text-large my-auto f-center weight_700 text-nowrap"
        data-tst="choose_tournament_structure_title"
      >
        {{ $t('solfigr.icm.choose_tournament_structure') }}
      </div>
    </div>

    <div
      class="f-column mh-0"
      style="min-width: clamp(1px, 52rem, calc(100vw - 4rem))"
    >
      <div
        v-if="icm_call.error || icm_call_custom.error"
        class="gw_box mt-4"
        style="background: var(--clr-black-0-3)"
      >
        <IconAndText
          icon="mdi-alert-circle-outline"
          class="pa-8"
          style="--icon-size: 5rem; --icon-color: var(--clr-error)"
          :title="$t('messages.oops_error')"
          :subtitle="$t('messages.opps_error_sub')"
        >
        </IconAndText>
      </div>

      <div
        v-else
        class="f-column mt-2 wh-0 scroll-bottom-overlaya position-relative"
        :class="{ 'gw_loading no-events': icm_call.loading || icm_call_custom.loading }"
        style="
          overflow: hidden;
          flex: 1 1 auto;
          max-height: 100%;
          --clr-scrl-back: var(--clr-black-1);
          --scrl-height: 1rem;
          --scrlb-inset: auto auto -1px 0;
        "
      >
        <div
          class="d-flex f-column flex-1 no-scroll-track"
          style="overflow-y: auto; overflow-x: hidden; gap: 0.75rem; padding: 0 0 0rem 0"
        >
          <ExpandCard
            v-for="table in siteTables"
            :key="table.site"
            :opened="false"
            style="
              --radius-open: 8px;
              --radius-closed: 8px;
              --max-height: calc(100vh - 15rem);
              --clr-back-content: var(--clr-black-0-3);
              --content-paddings: 0.5rem;
              --content-display: flex;
            "
            :scrollViewProps="{
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            }"
            class="gw_loading_text"
            :data-tst="`cardexpand_icm_${table.site}`"
          >
            <template #title>
              <GwSiteItem
                v-if="!icm_call.error && icm_call.loaded"
                :siteId="table.site || ''"
                :icon="table.hasSite ? 'mdi-account-circle clr-primary' : ''"
                :title="
                  table.hasSite
                    ? $t('solfigr.icm.my_presets')
                    : table.site
                      ? ''
                      : $t('common.unknown')
                "
              />
            </template>

            <IcmStructuresTable
              v-if="!icm_call.error && icm_call.loaded"
              :items="table.items"
              :tstPrefix="table.site"
              :hasDelete="table.hasDelete"
              v-bind="$attrs"
              @delete:item="deleteItem"
            />
          </ExpandCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSiteItem } from '@/helpers/helpers'
import table_mix from '@/components/DataTables/table_mix'
import fetch_mix from '@/mixins/fetch_mix'
import IcmStructuresTable from '@/components/DataTables/v2/tables/IcmStructuresTable/IcmStructuresTable'
import links_mix from '@/mixins/links_mix'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import GwSiteItem from '@/components/DataTables/Filters/new/items/GwSiteItem'
import IconAndText from '@/components/Poker/Overlays/IconAndText'

export default {
  name: 'IcmStructuresTables',
  components: {
    IcmStructuresTable,
    ExpandCard,
    GwSiteItem,
    IconAndText,
  },
  mixins: [table_mix, fetch_mix, links_mix],
  props: {},
  data() {
    return {
      icm_call_custom: {
        conf: {
          endpoint: 'tournaments/preset/',
          apiVersion: 'v4',
          params: {
            limit: 1000, // 1k is max ... soon it will be 10k
            offset: 0,
          },
        },
        loading: false,
        loaded: false,
        status: 0,
      },
      icm_call: {
        conf: {
          endpoint: 'tournaments/predefined/',
          apiVersion: 'v4',
          params: {
            limit: 1000, // 1k is max ... soon it will be 10k
            offset: 0,
          },
        },
        loading: false,
        loaded: false,
        status: 0,
      },
      siteTables: [...new Array(7).keys()],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async deleteItem(item) {
      const delete_call = {
        conf: {
          method: 'delete',
          endpoint: `tournaments/preset/${item.id}/`,
          apiVersion: 'v4',
          data: {},
        },
        loading: false,
        loaded: false,
        status: 0,
        error: null,
      }
      const { data, error } = await this.fch_getData(delete_call)
      if (error) {
        this.$store.dispatch('messages', {
          type: 'error',
          text: this.$t('messages.error_success_preset_delete', { status: delete_call.status }),
        })
        return
      }
      this.$store.dispatch('messages', {
        type: 'success',
        text: this.$t('messages.success_preset_delete'),
        hide: true,
      })

      this.siteTables = this.siteTables.map(ss => ({
        ...ss,
        items: ss.items.filter(i => i.id !== item.id),
      }))
    },
    getSiteTables(data, customSite) {
      const sites = customSite
        ? [customSite]
        : [...new Set(data.items.map(item => item.site))].sort()

      const primaryOrder = [
        'gtowizard',
        'events',
        'pokerstars',
        'ggpoker',
        'ipoker',
        'wpn',
        'winamax',
        '888',
        'partypoker',
      ]

      let res = sites.map(site => ({
        hasSite: !!customSite,
        hasDelete: !!customSite,
        site: customSite || site,
        order: primaryOrder.findIndex(id => {
          const orderItem = getSiteItem(id)
          const siteItem = getSiteItem(site)
          return orderItem && siteItem && orderItem.id === siteItem.id
        }),
        items: customSite ? data.items : data.items.filter(item => item.site === site),
      }))

      res = res.sort((a, b) => a.order - b.order)

      // console.log(res)
      return res
    },
    async getData() {
      const { data: data_custom, error: error_custom } = await this.fch_getData(
        this.icm_call_custom,
      )
      const { data, error } = await this.fch_getData(this.icm_call)
      if ((error, error_custom)) {
        return
      }

      const custom = this.getSiteTables(data_custom, 'my_presets')
      const predefined = this.getSiteTables(data)

      this.siteTables = [...custom, ...predefined]
    },
  },
}
</script>
